import axios from 'axios';

/** ipgeolocation.io fields we read (API may return more). */
export type IpGeolocationResponse = {
  country_name?: string;
  /** ISO 3166-1 alpha-2 - canonical for Stripe presentment on the backend. */
  country_code2?: string;
  /** Comma-separated locale hints, e.g. `en-US,en`; used on Auth for i18n. */
  languages?: string;
};

const IPGEO_API_KEY = '3be9216964854320bcf9a0c55568fffa';

export const getLocation = async (): Promise<IpGeolocationResponse> => {
  const { data } = await axios.get<Record<string, unknown>>(
    `https://api.ipgeolocation.io/ipgeo?apiKey=${IPGEO_API_KEY}`,
  );
  const country_name =
    typeof data.country_name === 'string' ? data.country_name : undefined;
  const code2 =
    (typeof data.country_code2 === 'string' && data.country_code2) ||
    (typeof data.country_code === 'string' && data.country_code) ||
    undefined;
  const languages =
    typeof data.languages === 'string' ? data.languages : undefined;
  return { country_name, country_code2: code2, languages };
};
